export default {
  notEvaluatingDescription:
    'Please add a reason as to why this experiment will not be evaluated.',
  notEvaluatingHeader: 'Reason for not evaluating:',
  completingDescription:
    'Please summarize the changes that were made and the reason for updating the evaluation.',
  completingHeader: 'Changes made:',
}
